// Angular
import { Component, OnInit } from '@angular/core';

// Services
import { WISEService } from 'app/_services';

// Formly
import { FieldType } from '@ngx-formly/core';

// 3rd part
import { friendlyFormatIBAN } from 'ibantools';
import { isValidIBAN } from 'ibantools';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'formly-field-input-iban',
    templateUrl: './ibaninput.type.component.html',
})
export class FormlyFieldInputIBAN extends FieldType implements OnInit {
    public isValidIBAN = null;

    constructor(
        private wiseService: WISEService,
        private toastr: ToastrService,
    ) {
        super();
    }

    get type() {
        return this.to.type || 'text';
    }

    public hasIBAN(): boolean {
        return this.formControl.value !== null &&  this.formControl.value !== '';
    }

    public validateIBAN(): void {
        const iban = this.formControl.value;

        if (iban) {
            const IBAN = iban
                .trim()
                .replace(/\s/g, '')
                .toUpperCase();

            //this.model[this.field.key] = friendlyFormatIBAN(IBAN);
            this.set(this.field.key, friendlyFormatIBAN(IBAN));

            this.isValidIBAN = isValidIBAN(IBAN);

            if (!this.isValidIBAN) {
                const iBANLabel = this.field.templateOptions.label || 'IBAN bankrekeningnummer';
                this.toastr.error(iBANLabel + ' is niet geldig', 'IBAN');
            }
        } else {
            this.isValidIBAN = null;
        }
    }

    private set(path, value) {
        let schema = this.model;  // a moving reference to internal objects within obj
        const pList = path.split('.');
        const len = pList.length;

        for (let i = 0; i < len - 1; i++) {
            const elem = pList[i];

            if (!schema[elem]) {
                schema[elem] = {};
            }

            schema = schema[elem];
        }

        schema[pList[len - 1]] = value;
    }

    ngOnInit(): void {
        const iban = this.model[this.field.key];

        if (iban) {
            const IBAN = iban
                .trim()
                .replace(/\s/g, '')
                .toUpperCase();

            this.isValidIBAN = isValidIBAN(IBAN);
        }

    }
}
